ux-list {
  display: block;

  > ul {
    list-style-type: none;
    margin: 0;
    padding: 0;

    > li {
      padding: 0 15px;
    }
  }

  .ux-dropdown__item--hidden {
    display: none;
  }
}
